export class Account {
    'id';
    'cloudProvider';
    'providerAccountId';
    'role';
    'regions';
    'tags';
    'name';
    'tenantId';
    'applicationId';
    'principalId';
    'overrideDefaultNetworkConfig';
    'awsOrganizationId';
    'gcpOrganizationId';
    'gcpFolderID';
    'atlasOrganizationId';
    'accountType';
    'isInternal';
    'state';
    'installedVersion';
    'installationMethod';
    'latestVersion';
    'isJobMetricsEnabled';
    'jobMetricsTargetRegion';
    'eonCustomAccountName';
    'providerAccountName';
    'eonInternalAzureResourceGroupName';
    'createdTime';
    'azureManagementGroup';
    'azureResourceGroupName';
    'isCustomerOwned';
    'gcsServiceAgent';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "string",
            "format": ""
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "applicationId",
            "baseName": "applicationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "principalId",
            "baseName": "principalId",
            "type": "string",
            "format": ""
        },
        {
            "name": "overrideDefaultNetworkConfig",
            "baseName": "overrideDefaultNetworkConfig",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "awsOrganizationId",
            "baseName": "awsOrganizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "gcpOrganizationId",
            "baseName": "gcpOrganizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "gcpFolderID",
            "baseName": "gcpFolderID",
            "type": "string",
            "format": ""
        },
        {
            "name": "atlasOrganizationId",
            "baseName": "atlasOrganizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountType",
            "baseName": "accountType",
            "type": "CloudAccountType",
            "format": ""
        },
        {
            "name": "isInternal",
            "baseName": "isInternal",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "AccountState",
            "format": ""
        },
        {
            "name": "installedVersion",
            "baseName": "installedVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "installationMethod",
            "baseName": "installationMethod",
            "type": "RoleInstallationMethod",
            "format": ""
        },
        {
            "name": "latestVersion",
            "baseName": "latestVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "isJobMetricsEnabled",
            "baseName": "isJobMetricsEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "jobMetricsTargetRegion",
            "baseName": "jobMetricsTargetRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonCustomAccountName",
            "baseName": "eonCustomAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerAccountName",
            "baseName": "providerAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonInternalAzureResourceGroupName",
            "baseName": "eonInternalAzureResourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdTime",
            "baseName": "createdTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "azureManagementGroup",
            "baseName": "azureManagementGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "azureResourceGroupName",
            "baseName": "azureResourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "isCustomerOwned",
            "baseName": "isCustomerOwned",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gcsServiceAgent",
            "baseName": "gcsServiceAgent",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Account.attributeTypeMap;
    }
    constructor() {
    }
}
